// extracted by mini-css-extract-plugin
export default {"card":"DocumentCard_card__Vhsde","content":"DocumentCard_content__ppl+1","name":"DocumentCard_name__B+wR0","meta":"DocumentCard_meta__M7HeS"};